var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { css, html, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";
import { defaults, monospace } from "../style";
import "./ImportedFauxPrimitive";
/**
 * Todo: Different styling for different types of primitives
 */
let PrimitiveComponent = class PrimitiveComponent extends LitElement {
    render() {
        if (typeof this.el === "string") {
            return `"${this.el}"`;
        }
        else if (typeof this.el === "number") {
            return this.el.toString();
        }
        else if (typeof this.el === "boolean") {
            return this.el ? "True" : "False";
        }
        else if (this.el === null || this.el === undefined) {
            return "None";
        }
        else if (this.el[0] === "SPECIAL_FLOAT") {
            return this.el[1];
        }
        else if (this.el[0] === "IMPORTED_FAUX_PRIMITIVE") {
            return html `<tc-imported-faux-primitive .el=${this.el}></tc-imported-faux-primitive>`;
        }
        else {
            // Should never happen
            return "?";
        }
    }
};
PrimitiveComponent.styles = [defaults, css `
        :host {
            font-family: ${monospace};
            white-space: pre;
        }
        
        tc-imported-faux-primitive {
            white-space: normal;
        };
    `];
__decorate([
    property()
], PrimitiveComponent.prototype, "el", void 0);
PrimitiveComponent = __decorate([
    customElement('tc-primitive')
], PrimitiveComponent);
export { PrimitiveComponent };
//# sourceMappingURL=PrimitiveComponent.js.map